// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.26336"][{"961":0}[chunkId]] || "1.26340") + "/" + chunkId + ".js";
};